/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyTrashIcon = createIcon("EmptyTrashIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M43 46h22v-4c0-.552-.44-1-1.002-1H44.002A.999.999 0 0043 42v4Zm22.003-7c1.103 0 1.997.896 1.997 1.997V46h12.008c.509 0 .928.383.985.883L80 47a1 1 0 01-.992 1H73v41.994A2.008 2.008 0 0170.997 92H37.003A2.005 2.005 0 0135 89.994V48h-6.008A.994.994 0 0128 47a1 1 0 01.992-1H41v-5.003c0-1.103.895-1.997 1.997-1.997h22.006Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 40h22v-4c0-.552-.44-1-1.002-1H50.002A.999.999 0 0049 36v4Zm36.008 0c.509 0 .928.383.985.883L86 41a1 1 0 01-.992 1H79v41.994A2.008 2.008 0 0176.997 86H43.003A2.005 2.005 0 0141 83.994V42h-6.008A.994.994 0 0134 41a1 1 0 01.992-1H47v-5.003c0-1.103.895-1.997 1.997-1.997h22.006c1.103 0 1.997.896 1.997 1.997V40h12.008Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 83.003c0 .55.455.997 1 .997h32c.553 0 1-.443 1-.997V42H43v41.003Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 50c.276 0 .5.228.5.502v21.996a.507.507 0 01-.412.494L54.5 73a.503.503 0 01-.5-.502V50.502c0-.247.183-.451.412-.494L54.5 50Zm11 0c.276 0 .5.228.5.502v21.996a.507.507 0 01-.412.494L65.5 73a.503.503 0 01-.5-.502V50.502c0-.247.183-.451.412-.494L65.5 50Z",
    fill: "#0C0D0D"
  }));
}, {
  "i18nKey": "svg.EmptyTrashIcon"
});